<div class="row">
    <div class="col-xl-9 mb-4">

    </div>
    <div class="col-xl-3 mb-4 ct_mt_top_68">

        <div class="ct_right_sidebar">
            <div class="mb-4">
                <div *ngIf="selectedFacility">
                    <!-- <select class="ct_all_vender_select" [(ngModel)]="selectedFacility"
                        (change)="onFacilityChange($event)">
                        <option value="" *ngFor="let items of dashboardData" [value]="items.ID">{{items.AssestType}}
                        </option>

                    </select> -->
                    <ng-container  >
                        <p-dropdown class="ct_select_op_input ct_chev_icon_dark230" required  #country="ngModel"
                        [options]="dashboardData" optionLabel="AssestType" 
                        optionValue="ID" [(ngModel)]="selectedFacility" [ngModelOptions]="{standalone: true}" [scrollable]="true"
                        (onChange)="onFacilityChange($event)">
                        <ng-template let-option pTemplate="item">
                            <div class="d-flex justify-content-between">
                              <div>{{ option.AssestType }}</div>
                              <div class="d-flex justify-content-end pt-1 ml-1">
                                <i class="fa" [class.fa-users]="isArray(option.ID)" [class.fa-user]="!isArray(option.ID)"></i>
                              </div>
                            </div>
                          </ng-template>
                    </p-dropdown>
                    </ng-container>
                    <div class="mt-4">
                        <p class="mb-1 ct_fw_500">Calendar Year</p>
                        <p-calendar class="w-100 ct_input_dark_text_145" [(ngModel)]="year" ngModel name="year" year
                            view="year" dateFormat="yy" inputId="yearpicker" styleClass="pcalender"   (ngModelChange)="onFacilityChange($event)"
                            [showIcon]="true"></p-calendar>
                        <!-- <select class="ct_period_select w-100">
                            <option value="">2023-2024</option>
                            <option value="">2023-2024</option>
                        </select> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-12">
        <div class="row">

            <div class="col-xl-3 mb-4">
                <div class="ct_grey_border_1 ">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                        <div>
                            <h5 class="ct_font_16">Emissions in Travel</h5>
                            <h3 class="ct_fs_24">{{airTotal | number:'1.2-2'}}</h3>
                            <p class="mb-0">tCO2e</p>
                        </div>
                       
                    </div>
                    <div id="ct_emission_by_travel" *ngIf="donotOptions1">
                        <apx-chart [series]="donotOptions1.series" [chart]="donotOptions1.chart"
                            [labels]="donotOptions1.labels" [legend]="donotOptions1.legend"
                            [colors]="donotOptions1.colors" [responsive]="donotOptions1.responsive"></apx-chart>
                    </div>
                </div>
            </div>
    
            <div class="col-xl-3 mb-4">
                <div class="ct_grey_border_1">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                        <div>
                            <h5 class="ct_font_16">Emssions by Cost centre</h5>
                            <h3 class="ct_fs_24">{{totalCostCentre}}</h3>
                            <p class="mb-0">tCO2e</p>
                        </div>
                       
                    </div>
                    <div id="ct_cost_center" *ngIf="donotOptions3">
                        <apx-chart [series]="donotOptions3.series" [chart]="donotOptions3.chart"
                            [labels]="donotOptions3.labels" [legend]="donotOptions3.legend"
                            [colors]="donotOptions3.colors" [responsive]="donotOptions3.responsive"></apx-chart>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 mb-4">
                <div class="ct_grey_border_1 ">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                        <div>
                            <h5 class="ct_font_16">Travel Emissions  / month (tCO2e)</h5>
                            <!-- <p class="mb-0">FY 2023-2024</p> -->
                        </div>
                    </div>
                    <div id="ct_emission_by_month" *ngIf="chartOptions">
                        <apx-chart
                        [series]="chartOptions.series"
                        [chart]="chartOptions.chart"
                        [dataLabels]="chartOptions.dataLabels"
                        [plotOptions]="chartOptions.plotOptions"
                        [yaxis]="chartOptions.yaxis"
                        [legend]="chartOptions.legend"
                        [fill]="chartOptions.fill"
                        [colors] = "chartOptions.colors"
                        [stroke]="chartOptions.stroke"
                        [tooltip]="chartOptions.tooltip"
                        [xaxis]="chartOptions.xaxis"
                      ></apx-chart>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">

            <div class="col-xl-6">
                <h4 class="text-center mb-4">Air Travel Emissions</h4>
                <div class="row">
                    <div class="col-xl-6 mb-4">
                        <div class="ct_grey_border_1 ">
                            <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                                <div>
                                    <h5 class="ct_font_16">By Flight type</h5>
                                    <h3 class="ct_fs_24">{{flightTypeTotal | number:'1.2-2'}}</h3>
                                    <p class="mb-0">tCO2e</p>
                                </div>
                              
                            </div>
                            <div id="ct_business_divisions">
                                <div id="ct_cost_center" *ngIf="donotOptions2">
                                    <apx-chart [series]="donotOptions2.series" [chart]="donotOptions2.chart"
                                        [labels]="donotOptions2.labels" [legend]="donotOptions2.legend"
                                        [colors]="donotOptions2.colors"
                                        [responsive]="donotOptions2.responsive"></apx-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 mb-4">
                        <div class="ct_grey_border_1">
                            <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                                <div>
                                    <h5 class="ct_font_16">By Flight Class</h5>
                                    <h3 class="ct_fs_24">{{flightTotal | number:'1.2-2'}}</h3>
                                    <p class="mb-0">tCO2e</p>
                                </div>
                              
                            </div>
                            <div id="By_employee_location" *ngIf="pieChart">
                                <apx-chart [series]="pieChart.series" [chart]="pieChart.chart"
                                    [labels]="pieChart.labels" [legend]="pieChart.legend"
                                    [responsive]="pieChart.responsive" [colors]="pieChart.colors"></apx-chart>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-xl-6">
                <h4 class="text-center mb-4">Ground Travel Emissions</h4>
                <div class="row">

                    <div class="col-xl-12 mb-4">
                        <div class="ct_grey_border_1">
                            <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                                <div>
                                    <h5 class="ct_font_16">Total Emission</h5>
                                    <h3 class="ct_fs_24">{{groundTotal | number:'1.2-2'}}</h3>
                                    <p class="mb-0">tCO2e</p>
                                </div>
                               
                            </div>
                            <div id="ct_net_zeo_donut" *ngIf="groupChart">
                                <apx-chart [series]="groupChart.series" [chart]="groupChart.chart"
                                    [dataLabels]="groupChart.dataLabels" [plotOptions]="groupChart.plotOptions"
                                    [yaxis]="groupChart.yaxis" [xaxis]="groupChart.xaxis" [legend]="groupChart.legend"
                                    [colors]="groupChart.colors" [grid]="groupChart.grid"></apx-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>